"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteProjectRelation = exports.postProjectRelation = exports.putProjectOrganization = exports.delProject = exports.postProject = exports.putProject = exports.getProject = exports.getProjects = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var path = root_1.projectManagementAuthorized + '/projects/';

var getProjects = function getProjects(authentication, queryParameters) {
  return common_1.get(authentication, path, queryParameters);
};

exports.getProjects = getProjects;

var getProject = function getProject(authentication, id) {
  return common_1.get(authentication, path + id);
};

exports.getProject = getProject;

var putProject = function putProject(authentication, project) {
  return common_1.put(authentication, path + project.id, project);
};

exports.putProject = putProject;

var postProject = function postProject(authentication, project) {
  return common_1.post(authentication, path, project);
};

exports.postProject = postProject;

var delProject = function delProject(authentication, id) {
  return common_1.del(authentication, path + id);
};

exports.delProject = delProject;

var putProjectOrganization = function putProjectOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, path, id, accessibility);
};

exports.putProjectOrganization = putProjectOrganization;

var postProjectRelation = function postProjectRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, path, id, relation);
};

exports.postProjectRelation = postProjectRelation;

var deleteProjectRelation = function deleteProjectRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, path, id, relationId);
};

exports.deleteProjectRelation = deleteProjectRelation;